/*
    Adapted from https://medium.com/siren-apparel-press/internationalization-and-localization-of-sirenapparel-eu-sirenapparel-us-and-sirenapparel-asia-ddee266066a2
*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function flattenMessages(nestedMessages:any, prefix = "") {
  return Object.keys(nestedMessages).reduce((messages:{ [key: string]: string; }, key) => {
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === "string") {
      messages[prefixedKey] = value
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    }
    return messages
  }, {})
}
